import { useEffect, useState } from 'react';
import { getLocalStorageItem, setLocalStorageItem } from '../../service/storage-service';
import { useMaintenanceStore } from '../../store/maintenance.store';
import { StorageKeyEnum } from '../../utils/enum';
import { IsStringNullEmptyOrUndefined } from '../../utils/null-check';
import './maintenance.css';

const MaintenanceAlert = () => {
    const { isShow, message } = useMaintenanceStore();
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        // Check session storage when component mounts
        const isHidden = getLocalStorageItem(StorageKeyEnum.MAINTENANCE_ALERT_HIDDEN);
        if (isHidden === 'true') {
            setIsVisible(false);
        }
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        setLocalStorageItem(StorageKeyEnum.MAINTENANCE_ALERT_HIDDEN, 'true');
    };

    if (!isShow || IsStringNullEmptyOrUndefined(message) || !isVisible) return <></>;

    return (
        <div className="d-flex justify-content-center p-3 ms-4 maintenanceHeader">
            <div className="w-70 bg-white shadow">
                <div className="p-3">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        {/* Animated dot */}
                        <div className="dot-wrapper">
                            <div className="dot-pulse"></div>
                            <div className="dot-ping"></div>
                        </div>

                        <p className="m-0 fw-medium text-dark">
                            <span className="d-none d-sm-inline">Maintenance Notice:</span>
                            <span className="d-sm-none">Maintenance Notice:</span>
                            <small className="small px-1" dangerouslySetInnerHTML={{ __html: message }} />
                        </p>

                        {/* Close button */}
                        <button
                            className="btn-close ms-auto"
                            onClick={handleClose}
                            aria-label="Close"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MaintenanceAlert;
